// Whether the rail shows names or icons only. This browser's choice, like the theme:
// a narrow counter screen keeps it collapsed, a manager's wide one expanded.
const KEY = 'qms-rail'

export function readRailCollapsed(): boolean {
  try {
    return localStorage.getItem(KEY) === 'collapsed'
  } catch {
    return false
  }
}

export function saveRailCollapsed(collapsed: boolean) {
  try {
    if (collapsed) localStorage.setItem(KEY, 'collapsed')
    else localStorage.removeItem(KEY)
  } catch {
    // A private window: the choice holds for this visit.
  }
}
